import { Record } from 'immutable';

export const Provider = new Record({
  id: null,
  version: localStorage.getItem('version') || null,
  user : null,
  sessionId : null,
  dtCreated : null,
  dtExpiration : null,
  isPending: false,
  error: 0
});
